import { PrinterOptionsSchema } from "@redotech/redo-fulfillment-common/printer";
import * as z from "zod";

export const printParcelPackingSlips = {
  name: "printParcelPackingSlips" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(z.string()),
    printerId: z.number().optional(),
    printerOptions: PrinterOptionsSchema.optional(),
    templateId: z.string().optional(),
  }),
  output: z.object({ url: z.string() }),
};
